var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{staticClass:"mb-12",attrs:{"elevate-on-scroll":""}},[_c('v-spacer'),_c('LanguageSelectForPrivatePages',{staticClass:"language-dropdown"})],1),_c('div',{staticClass:"auth-layout-left-right-padding mb-12"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }